export class TipiDocumentoRequestDTO {
	codiceTipoDeposito: string;
}